import { ArrowUpRight, Menu, X } from "lucide-react";
import { useState } from "react";
import { NavLink } from "react-router-dom";
import { navigation } from "@/data/siteData";

function LinkItem({ item, mobile = false, onNavigate }) {
  return (
    <NavLink
      to={item.path}
      onClick={onNavigate}
      data-testid={`${mobile ? "mobile-" : ""}${item.testId}`}
      className={({ isActive }) => `header-link ${isActive ? "active" : ""}`}
    >
      {item.label}
    </NavLink>
  );
}

export default function SiteHeader() {
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);

  return (
    <header className="site-header">
      <div className="shell header-inner">
        <NavLink to="/" className="brand-lockup" data-testid="brand-home-link">
          <span className="brand-mark">AP</span>
          <span className="brand-copy">
            <span className="brand-name">Ashwini Patil</span>
            <span className="brand-domain">Data, AI &amp; decisions</span>
          </span>
        </NavLink>
        <nav className="header-nav" aria-label="Primary navigation" data-testid="primary-navigation">
          {navigation.map((item) => <LinkItem key={item.path} item={item} />)}
        </nav>
        <div className="header-actions">
          <NavLink to="/login" className="header-account-link" data-testid="header-login-link">Sign in</NavLink>
          <NavLink to="/connect" className="header-cta" data-testid="header-connect-link">
            Continue a conversation <ArrowUpRight size={14} />
          </NavLink>
        </div>
        <button
          type="button"
          className="menu-toggle"
          data-testid="mobile-menu-toggle"
          aria-expanded={open}
          aria-label={open ? "Close navigation" : "Open navigation"}
          onClick={() => setOpen((value) => !value)}
        >
          {open ? <X size={18} /> : <Menu size={18} />}
        </button>
      </div>
      {open && (
        <nav className="mobile-nav" aria-label="Mobile navigation" data-testid="mobile-navigation">
          {navigation.map((item) => <LinkItem key={item.path} item={item} mobile onNavigate={close} />)}
        </nav>
      )}
    </header>
  );
}
